import BigNumber from 'bignumber.js'
// utils
import { shouldShowDepositLimit } from '@/components/Withdraw/src/constants'

/**
 * 检查是否可以提交（确认按钮是否可点击）
 */
export const canSubmitAmount = (
  amount: string,
  maxBalance: string,
  approved: boolean
): boolean => {
  if (!amount || amount === '' || amount === '0' || amount === '0.00') {
    return false
  }

  const numAmount = parseFloat(amount)
  const numBalance = parseFloat(maxBalance)

  // 检查是否超过余额
  if (isNaN(numAmount) || isNaN(numBalance) || numAmount > numBalance) {
    return false
  }

  // 检查是否已授权（对于非ETH代币）
  if (!approved) {
    return false
  }

  return true
}

export const shouldShowLargeDepositWarning = (
  chainId: number,
  depositAmount: string,
  selectedToken: string
) => {
  // 根据链和代币判断是否需要显示大额充值警告
  if (!shouldShowDepositLimit(chainId, selectedToken)) {
    return false
  }

  try {
    const amountBN = new BigNumber(depositAmount || '0')
    const thresholdBN = new BigNumber('200000')

    // 检查是否为有效数字
    if (amountBN.isNaN() || thresholdBN.isNaN()) {
      return false
    }

    return amountBN.gte(thresholdBN)
  } catch (error) {
    // 如果出现任何错误，返回 false
    return false
  }
}

export const getEffectiveMaxAmountPure = (
  chainId: number,
  currentTokenBalance: string,
  selectedToken: string
) => {
  let maxAmount = currentTokenBalance || '0'

  // 根据链和代币判断是否需要限制最大输入金额
  if (shouldShowDepositLimit(chainId, selectedToken)) {
    try {
      const balanceBN = new BigNumber(maxAmount)
      const limitBN = new BigNumber('200000')

      // 如果余额超过20万，将最大可输入金额限制为20万
      if (balanceBN.gt(limitBN)) {
        maxAmount = '200000'
      }
    } catch (error) {
      // 如果计算出错，使用原始余额
      console.warn('Error calculating max amount limit:', error)
    }
  }

  return maxAmount
}

export * from './format'
